/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'licensing';
const componentName = 'license-add-panel-modal';
const prefix = `${moduleName}.${componentName}`;

export const cancelButtonLabel = `${prefix}.cancelButtonLabel`;
export const modalTitle = `${prefix}.modalTitle`;
export const licenseAddSuccessMessage = `${prefix}.licenseAddSuccessMessage`;
export const licenseKeyLabel = `${prefix}.licenseKeyLabel`;
export const licenseKeyPlaceholder = `${prefix}.licenseKeyPlaceholder`;

export const ENGLISH = {
    [cancelButtonLabel]: 'Cancel',
    [modalTitle]: 'Add License Key',
    [licenseAddSuccessMessage]: 'License key successfully applied.',
    [licenseKeyLabel]: 'License Key',
    [licenseKeyPlaceholder]: 'XXXXX-XXXXX-XXXXX-XXXXX-XXXXX',
};
